import React from 'react'
import NuevoPedido from '../components/NuevoPedido'

const articulosDeCompra = () => {
  return (
    <NuevoPedido />
  )
}

export default articulosDeCompra